import React from "react";
import {useEffect} from "react";
import {css, cx} from "@panda/css";

import {rpAppLink} from "@pg-mono/rp-routes";

import {gtmEventPostApplicationModal} from "../../../tracking/google_tag_manager/gtm_event_modal";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSuccessInfo} from "./ApplicationSuccessInfo";

interface IProps {
    className?: string;
    onClick: () => void;
    buttonClassName?: string;
    disableRedirectButton?: boolean;
    originalApplicationResponse: IApplicationData | null;
    isModal?: boolean;
    shouldRenderRecommendations?: boolean;
    onModalClose?: () => void;
}

export const ApplicationSuccessInfoModal = (props: IProps) => {
    const {originalApplicationResponse} = props;

    const isAuthenticated = useIsAuthenticated();

    const applicationUuid = originalApplicationResponse ? originalApplicationResponse.uuid : null;

    useEffect(() => {
        // gtm
        gtmEventPostApplicationModal("rekomendacje", "wyswietlenie");
    }, []);

    const onClickShowSentApplications = () => {
        // gtm
        gtmEventPostApplicationModal("rekomendacje", "klikniecie");
        // continue redirect
        const applicationUuidOrEmptyString = applicationUuid === null || applicationUuid === undefined ? "" : `#${applicationUuid}`;
        window.location.href = rpAppLink.myOffer() + applicationUuidOrEmptyString;
    };

    return (
        <ApplicationSuccessInfo
            className={cx(wrapperStyle, props.className)}
            buttonClassName={props.buttonClassName}
            onClick={props.onClick}
            onClickShowSentApplications={onClickShowSentApplications}
            disableRedirectButton={props.disableRedirectButton}
            isModal={props.isModal}
            isAuthenticated={isAuthenticated}
            onModalClose={props.onModalClose}
        />
    );
};

const wrapperStyle = css({
    md: {
        width: "896px",
        height: "auto"
    }
});
import React from "react";
import {useEffect} from "react";
import {css, cx} from "@panda/css";

import {rpAppLink} from "@pg-mono/rp-routes";

import {gtmEventPostApplicationModal} from "../../../tracking/google_tag_manager/gtm_event_modal";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSuccessInfo} from "./ApplicationSuccessInfo";

interface IProps {
    className?: string;
    onClick: () => void;
    buttonClassName?: string;
    disableRedirectButton?: boolean;
    originalApplicationResponse: IApplicationData | null;
    isModal?: boolean;
    shouldRenderRecommendations?: boolean;
    onModalClose?: () => void;
}

export const ApplicationSuccessInfoModal = (props: IProps) => {
    const {originalApplicationResponse} = props;

    const isAuthenticated = useIsAuthenticated();

    const applicationUuid = originalApplicationResponse ? originalApplicationResponse.uuid : null;

    useEffect(() => {
        // gtm
        gtmEventPostApplicationModal("rekomendacje", "wyswietlenie");
    }, []);

    const onClickShowSentApplications = () => {
        // gtm
        gtmEventPostApplicationModal("rekomendacje", "klikniecie");
        // continue redirect
        const applicationUuidOrEmptyString = applicationUuid === null || applicationUuid === undefined ? "" : `#${applicationUuid}`;
        window.location.href = rpAppLink.myOffer() + applicationUuidOrEmptyString;
    };

    return (
        <ApplicationSuccessInfo
            className={cx(wrapperStyle, props.className)}
            buttonClassName={props.buttonClassName}
            onClick={props.onClick}
            onClickShowSentApplications={onClickShowSentApplications}
            disableRedirectButton={props.disableRedirectButton}
            isModal={props.isModal}
            isAuthenticated={isAuthenticated}
            onModalClose={props.onModalClose}
        />
    );
};

const wrapperStyle = css({
    md: {
        width: "896px",
        height: "auto"
    }
});
